import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { ParticipantResource } from '../../../../../../../ParticipantsStore/Types';
import GroupParticipantsStore from '../../../../GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../../../../GroupParticipantsStore/Types';
import Reactions from './RemoveParticipant/RemoveParticipantStore/Reactions';
import RemoveParticipantStore from './RemoveParticipant/RemoveParticipantStore/Store';
import RowBody from './RowBody';

interface Props {
  resource: ParticipantResource;
  groupParticipantsResource: GroupParticipantsResource;
  groupParticipantsStore: GroupParticipantsStore;
}

function Row({ resource, groupParticipantsStore, groupParticipantsResource }: Props) {
  const store = useMemo(() => new RemoveParticipantStore(), []);
  return (
    <>
      <RowBody
        resource={resource}
        groupParticipantsResource={groupParticipantsResource}
        store={store}
      />
      <Reactions groupParticipantsStore={groupParticipantsStore} store={store} fireImmediately />
    </>
  );
}
export default observer(Row);
